import { Button, Tooltip } from 'antd';
import { RiTimeLine } from 'react-icons/ri';
import { DefinedTimeContentProps } from '../profile-dropdown.types';
import dayjs from 'dayjs';
import { truncateString } from '@modules/settings/subscription/utils/utils';
import { AppAvatar } from '@components/app-avatar';
import { useTranslation } from 'react-i18next';

export function DefinedTimeContent({
  userActiveStatus,
  profileUrl,
  userName,
  message,
  timeLabel,
  definedTime,
  handleDurationSelect,
  handleOpen,
  awayTime,
  icon,
}: DefinedTimeContentProps) {
  const formattedDate = dayjs(awayTime)?.format('MMM D, YYYY, hh:mm A');
  const { t } = useTranslation();
  return (
    <div className="flex flex-col min-w-[180px]  w-[230px] font-medium">
      {!userActiveStatus && (
        <div className="flex items-center gap-2 p-2 border-b border-gray-200">
          <span className="inline-flex shrink-0">
            <AppAvatar size={36} src={profileUrl} name={userName} className="border border-gray-200! shrink-0" />
          </span>
          <div>
            <Tooltip placement="bottom" title={<p className="text-xs text-slate-500">{message}</p>}>
              <p className="text-[15px]  text-text-700 leading-none mb-1! cursor-pointer">{`${truncateString(message, 14)} ${!userActiveStatus && icon}`}</p>
            </Tooltip>
            <p className="text-xs text-text-600 font-normal leading-none">{`Until ${timeLabel} ${formattedDate}`}</p>
          </div>
        </div>
      )}
      {definedTime?.map((item) => (
        <Button
          onClick={() => handleDurationSelect(item?.value)}
          key={item?.value}
          type="text"
          className="w-full justify-start! rounded-none! text-left"
        >
          {item?.label}
        </Button>
      ))}
      <hr className="text-text-50" />
      <Button onClick={handleOpen} type="text" className="w-full justify-start! rounded-none! capitalize!">
        <RiTimeLine size={20} /> {t('custom')}
      </Button>
    </div>
  );
}
